"use client";

import { useState } from "react";
import RecoveryPassword from "@/domains/auth/components/recovery-password";
import Registration from "@/domains/auth/components/registration";
import Login from "@/domains/auth/components/login";

interface AuthProps {
  activeTab: string;
}

export default function AuthModal({ activeTab = "registration" }: AuthProps) {
  const [tab, setTab] = useState(activeTab);

  const showTab = (name: string) => {
    setTab(name);
  };

  const renderComponent = () => {
    switch (tab) {
      case "registration":
        return <Registration onShowTab={showTab} />;
      /* case "otpVerification":
        return <OTPVerification onShowTab={showTab} />; */
      case "login":
        return <Login onShowTab={showTab} />;
      case "recoveryPassword":
        return <RecoveryPassword onShowTab={showTab} />;
      default:
        return null;
    }
  };

  return renderComponent();
}
